import { render } from "./GenomicsReport.vue?vue&type=template&id=3e652cee"
import script from "./GenomicsReport.vue?vue&type=script&lang=js"
export * from "./GenomicsReport.vue?vue&type=script&lang=js"

import "./GenomicsReport.vue?vue&type=style&index=0&id=3e652cee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__